module.exports = __webpack_public_path__ + "media/open_box2.8b8077b2.mp3";